import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getShare, getShareTokenFromLocationHash } from '../../services/shareService';
import SharedPropertyView from './SharedPropertyView';
import SitePreviewGate from '../sitePreview/SitePreviewGate';

/** Avec HashRouter, un lien #/login?share=… doit afficher LoginPage, pas la vue partagée. */
const PATHS_WHEN_SHARE_VIEW_DISABLED = ['/login', '/signup', '/reset-password'];

function getShareParam() {
  return getShareTokenFromLocationHash();
}

function isTokenFormat(share) {
  if (!share || typeof share !== 'string') return false;
  return share.length === 32 && /^[0-9a-fA-F]+$/.test(share);
}

/**
 * When the URL contains share=TOKEN (token format), load the share and render
 * SharedPropertyView without requiring auth. Otherwise render children.
 */
export default function ShareViewGate({ children }) {
  const location = useLocation();
  const [shareData, setShareData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const shareParam = getShareParam();

  useEffect(() => {
    if (!isTokenFormat(shareParam)) {
      setShareData(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    let cancelled = false;
    getShare(shareParam)
      .then((data) => {
        if (!cancelled && data?.snapshot) setShareData(data);
        else if (!cancelled) setError('Invalid or expired link');
      })
      .catch(() => {
        if (!cancelled) setError('Invalid or expired link');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [shareParam]);

  useEffect(() => {
    if (!isTokenFormat(getShareParam())) {
      setShareData(null);
      setError(null);
    }
  }, [location]);

  if (loading && getShareParam() && isTokenFormat(getShareParam())) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <span className="text-gray-600">Chargement…</span>
      </div>
    );
  }

  if (
    shareData
    && !PATHS_WHEN_SHARE_VIEW_DISABLED.includes(location.pathname)
  ) {
    return <SharedPropertyView shareData={shareData} />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return <SitePreviewGate>{children}</SitePreviewGate>;
}
